import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
// import { log } from 'console';
// import { METHODS } from 'http';
import { BrowserDataService } from '../services/browser-data.service';
import { WebTestingService } from '../services/webtesting.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoginService } from '../services/login.service';
import { first } from 'rxjs';
import io, { Socket } from 'socket.io-client';
import { CommonService } from '../services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-protean-browser',
    templateUrl: './protean-browser.component.html',
    styleUrls: ['./protean-browser.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class ProteanBrowserComponent implements OnInit {
  private baseUrl: any = environment.baseUrl;
  private baseUrlBrowser: any = environment.baseUrlBrowser;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  modalRef!: MatDialogRef<any>;
  msg: string = "";
  math!: Math;
  searchText = '';
  wsBrowserUpdates: Socket;
  domainUrl: string;


  activeTab: any = 'windows';
  trustedUrl: SafeResourceUrl | null = null;
  showWindowsListOs: boolean = true;
  showLinuxListOs: boolean = false;
  showMacListOs: boolean = false;
  showbrowser: boolean = true;
  windowsBrowsers: any = [];
  macBrowsers: any = [];
  linuxBrowsers: any = [];
  browserDetails: any[] = [];
  Loginprivilege: any;
  // browserDetails: any = [
  //   {
  //     "accessUrl": "https://axisprotean.apmosys.com/windows6",
  //     "automationPort": 4406,
  //     "browser": "chrome",
  //     "id": "windows6",
  //     "ip": "192.168.0.137",
  //     "os": "windows",
  //     "password": "Apmosys@123",
  //     "port": 3394,
  //     "user": null,
  //     "username": "apmosys"
  //   }, {
  //     "accessUrl": "https://axisprotean.apmosys.com/windows2",
  //     "automationPort": 4402,
  //     "browser": "edge",
  //     "id": "windows2",
  //     "ip": "192.168.0.137",
  //     "os": "windows",
  //     "password": "Apmosys@123",
  //     "port": 3390,
  //     "user": null,
  //     "username": "apmosys"
  //   }, {
  //     "accessUrl": "https://axisprotean.apmosys.com/windows4",
  //     "automationPort": 4404,
  //     "browser": "chrome",
  //     "id": "windows4",
  //     "ip": "192.168.0.137",
  //     "os": "windows",
  //     "password": "Apmosys@123",
  //     "port": 3392,
  //     "user": null,
  //     "username": "apmosys"
  //   }, {
  //     "accessUrl": "https://axisprotean.apmosys.com/windows3",
  //     "automationPort": 4403,
  //     "browser": "edge",
  //     "id": "windows3",
  //     "ip": "192.168.0.137",
  //     "os": "windows",
  //     "password": "Apmosys@123",
  //     "port": 3391,
  //     "user": null,
  //     "username": "apmosys"
  //   }, {
  //     "accessUrl": "https://axisprotean.apmosys.com/windows5",
  //     "automationPort": 4405,
  //     "browser": "chrome",
  //     "id": "windows5",
  //     "ip": "192.168.0.137",
  //     "os": "windows",
  //     "password": "Apmosys@123",
  //     "port": 3393,
  //     "user": null,
  //     "username": "apmosys"
  //   }, {
  //     "accessUrl": "https://axisprotean.apmosys.com/windows1",
  //     "automationPort": 4401,
  //     "browser": "edge",
  //     "id": "windows1",
  //     "ip": "192.168.0.137",
  //     "os": "windows",
  //     "password": "Apmosys@123",
  //     "port": 3389,
  //     "user": null,
  //     "username": "apmosys"
  //   }, {
  //     "accessUrl": "https://axisprotean.apmosys.com/mac1",
  //     "automationPort": 4444,
  //     "automationUrl": "https://axisprotean.apmosys.com/safari1",
  //     "browser": "safari",
  //     "id": "macmini3",
  //     "ip": "192.168.3.131",
  //     "os": "macOS",
  //     "password": "Apmosys@123",
  //     "port": null,
  //     "user": null,
  //     "username": "macmini3"
  //   }
  // ];
  filteredBrowsers: any[] = [];
  columns = [
    {
      name: 'browserVersion'
    },
    {
      name: 'browser'
    },
    {
      name: 'automationUrl'
    },
    {
      name: 'id'
    }, {
      name: 'ip'
    }
  ]
  versionList = [129, 128, 127, 126, 125, 124, 124, 123, 122, 121, 120]
  activeVesrion: number = 0;
  activeBroswer: number = 0
  activeResolution: number = 0;
  activeWindowsVerion: number = 0;
  activeMacOsVersion: number = 0;
  activeLinuxOsVersion: number = 0;
  busyNumber: number = 0;
  usableNumber: number = 0;
  totalNumber: number = 0;
  item: any = {};
  userObj: any = {};
  constructor(
    private http: HttpClient,
    private dataService: BrowserDataService,
    private webTestingService: WebTestingService,
    private router: Router,
    private dialog: MatDialog,
    private loginService: LoginService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    let user: any = JSON.parse(localStorage.getItem('currentUser'));
    if (!this.dataService.getBrowserSocketConnectionStatus()) {
      this.domainUrl = window.location.href;
      this.domainUrl = this.dataService.getBaseUrl(this.domainUrl);
      this.wsBrowserUpdates = io(this.domainUrl, {
        path: '/nbrowser/socket.io',  // Changed from '/socket.io' to '/nbrowser/socket.io/'
        reconnection: false,
        transports: ['websocket'],
        withCredentials: true
      });

      this.dataService.setBrowserSocketConnectionStatus(true);
      this.dataService.setSocketInstance(this.wsBrowserUpdates); // Store in service

      this.wsBrowserUpdates.on('browsers_out', (data: any) => {
        if (user.userObj.browsersAcquired == data.id && data.action === 'released' && user.email === data.mail) {
          // If the browser is released and it matches the current user's browser
          // Update the user status to false and clear the browser acquisition
          this.dataService.updateUserStatusToFalse(user.userObj).subscribe({
            next: (response) => {
              //update the socket about the browser released
              let browserData = {
                "mail": user.email,
                "id": user.userObj.browsersAcquired,
                "action": "released"
              }
              this.wsBrowserUpdates.emit('browsers_in', browserData);
            },
            error: (error) => {
              console.error('Error:', error);
            },
          });
          user.userObj.browsersAcquired = null;
          localStorage.setItem('currentUser', JSON.stringify(user));
        } else if (user.userObj.browsersAcquired != data.id && data.action === 'acquired' && user.email === data.mail) {
          // If already a browser is acquired and the user requests another browser
          // Update the user status to false for the previously acquired browser
          // and navigate to the new browser
          this.dataService.updateUserStatusToFalse(user.userObj).subscribe({
            next: (response) => {
              //update the socket about the browser released
              let browserData = {
                "mail": user.email,
                "id": user.userObj.browsersAcquired,
                "action": "released"
              }
              this.wsBrowserUpdates.emit('browsers_in', browserData);
            },
            error: (error) => {
              console.error('Error:', error);
            },
          });
          user.userObj.browsersAcquired = null;
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.commonService.setActiveTab('/webscreen/');
          this.router.navigate(['/webscreen', data.id]);
          this.showbrowser = false;
        }
        console.log('Parent - Browser update received:', data);
        this.browserDetails = JSON.parse(data.browsers);
        this.formatBrowserDetails();
        this.segregateBrowsers();
      });
    } else {
      this.wsBrowserUpdates = this.dataService.getSocketInstance(); // Retrieve from service
      this.wsBrowserUpdates.on('browsers_out', (data: any) => {
        console.log('Parent - Browser update received:', data);
        this.browserDetails = JSON.parse(data.browsers);
        this.formatBrowserDetails();
        this.segregateBrowsers();
      });
    }

    this.math = Math;
    this.loginService.getUserObject().pipe(first()).subscribe((userObjResponse: any) => {
      this.Loginprivilege = userObjResponse.user.privilege;
    });
    this.getbrowserList()
    this.webTestingService.formatTrigger$.subscribe(() => {
      this.formatBrowserDetails();
    });
  }

  getbrowserList() {
    let user: any = JSON.parse(localStorage.getItem('currentUser'));
    this.userObj.mail = user.email;
    const group = user.userObj.group;
    console.log("Group",group)
    this.dataService.getBrowserList(group).subscribe({
      next: (response) => {
        this.browserDetails = response; 
        this.formatBrowserDetails();
        this.segregateBrowsers();
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }

  formatBrowserDetails() {
    this.totalNumber = this.browserDetails.length;
    this.busyNumber = 0;
    this.usableNumber = 0;
    this.browserDetails.forEach((item: any) => {
      //set the busy and usable numbers
      if (item.user != null) this.busyNumber++;
      else this.usableNumber++;
      const formattedName = item.id.replace(/([a-zA-Z])(\d)/g, '$1 $2');
      switch (item.browser) {
        case 'chrome': {
          item.img = "/assets/images/chrome.png";
          item.name = formattedName;
          break;
        }
        case 'edge': {
          item.img = "/assets/images/Edge.png";
          item.name = formattedName;
          break;
        }
        case 'safari': {
          item.img = "/assets/images/Safari.png";
          item.name = formattedName;
          break;
        }
      }
    });
  }
  disconnectBrowser(item: any) {
    if (this.Loginprivilege === 'admin' || item.user === this.userObj.mail) {
      const data = {
        email: item.user,
        browserId: null
      };
      let browserData = {
        "mail": this.userObj.mail,
        "id": item.id,
        "action": "released"
      }
      this.wsBrowserUpdates.emit('browsers_in', browserData);

      this.http.post(`${this.baseUrl}/api/v1/browsersAcquired`, data).subscribe((response: any) => {
        if (response.success) {
          const userObj = { mail: item.user, id: item.id };
          this.dataService.updateUserStatusToFalse(userObj).subscribe({
            next: (response) => {
              this.getbrowserList();
              this.webTestingService.triggerFormatDetails();
              let currentUser: any = localStorage.getItem('currentUser');
              if (currentUser) {
                currentUser = JSON.parse(currentUser);
                if (currentUser.email === item.user) {
                  currentUser.userObj.browsersAcquired = null;
                  localStorage.setItem('currentUser', JSON.stringify(currentUser));
                }
              }
            },
            error: (error) => {
              console.error('Error:', error);
            }
          });
        }
      });
    }
  }

  segregateBrowsers() {
    this.windowsBrowsers = [];
    this.macBrowsers = [];
    this.linuxBrowsers = [];
    this.browserDetails.forEach((item: any) => {
      switch (item.os) {
        case 'windows': {
          this.windowsBrowsers.push(item);
          break;
        }
        case 'macOS':
        case 'macos': {
          this.macBrowsers.push(item);
          break;
        }
        case 'linux': {
          this.linuxBrowsers.push(item);
          break;
        }
      }
    });
    this.windowsBrowsers.sort((a: any, b: any) => a.id.localeCompare(b.id));
    this.macBrowsers.sort((a: any, b: any) => a.id.localeCompare(b.id));
    this.linuxBrowsers.sort((a: any, b: any) => a.id.localeCompare(b.id));
  }

  setActiveTab(activetab: string) {
    this.activeTab = activetab;
  }

  Launch(item: any) {
    let url = item.accessUrl;
    if (url) {
      this.item = item;
      this.userObj.id = item.id;
      let user: any = localStorage.getItem('currentUser');
      user = JSON.parse(user);
      let data = {
        'email': user.email,
        'browserId': item.id
      }
      this.http.post(`${this.baseUrl}` + '/api/v1/browsersAcquired', data).subscribe((response: any) => {
        if (response.success) {
          this.commonService.setActiveTab('/webscreen/');
          this.router.navigate(['/webscreen', item.id]);
          this.showbrowser = false;
          this.formatBrowserDetails();
        } else {
          if (response?.browserId) {
            // If a browser is already in use, release the acquired browser and take the new one
            this.userObj.id = response.browserId;
            this.dataService.updateUserStatusToFalse(this.userObj).subscribe({
              next: (response) => {
                this.commonService.setActiveTab('/webscreen/');
                this.router.navigate(['/webscreen', item.id]);
                this.showbrowser = false;
                this.formatBrowserDetails();
              },
              error: (error) => {
                console.error('Error:', error);
              },
            });
          } else {
            this.msg = response.message;
            this.openAlertMod(this.alertTemplate, this.msg)
          }
        }
      })
    } else {
      this.trustedUrl = null;
    }
    // if (url) {
    //   this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    //   this.dataService.updateUserStatus(this.userObj).subscribe({
    //     next: (response) => {
    //       this.formatBrowserDetails();
    //     },
    //     error: (error) => {
    //       console.error('Error:', error);
    //     },
    //   });
    // } else {
    //   this.trustedUrl = null; // Clear iframe if input is empty
    // }
  }

  filterBrowserDetails() {
    const text = this.searchText.trim().toLowerCase();

    if (!text) {
      this.segregateBrowsers();
      return;
    }

    this.windowsBrowsers = this.windowsBrowsers.filter(item => {
      return Object.values(item).some(value =>
        String(value).toLowerCase().includes(text)
      );
    });

    this.macBrowsers = this.macBrowsers.filter(item => {
      return Object.values(item).some(value =>
        String(value).toLowerCase().includes(text)
      );
    });

    this.linuxBrowsers = this.linuxBrowsers.filter(item => {
      return Object.values(item).some(value =>
        String(value).toLowerCase().includes(text)
      );
    });
  }


  alreadyOneBrowserInUse() {
    this.openAlertMod(this.alertTemplate, 'Already a browser is in use!');
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

  trackByFn(index: number, item: any): any {
    return item.id; // Replace `id` with a unique property of your `item` object
  }

}
